
import { Mail, Phone } from 'lucide-react';
const ContactCards = () => {
  return <div className="grid grid-cols-2 gap-4 mb-10 md:mb-16">
      <a href="mailto:oss@thematmonster.com" className="bg-card p-4 rounded-lg text-center flex flex-col items-center justify-center transition-transform hover:scale-105">
        <div className="w-12 h-12 bg-secondary/10 rounded-full flex items-center justify-center mb-3">
          <Mail className="h-6 w-6 text-secondary" />
        </div>
        <h3 className="font-semibold mb-1 text-primary text-sm">Email Us</h3>
        <p className="text-primary/70 text-xs">oss@thematmonster.com</p>
      </a>
      
      <a href="tel:+1234567890" className="bg-card p-4 rounded-lg text-center flex flex-col items-center justify-center transition-transform hover:scale-105">
        <div className="w-12 h-12 bg-secondary/10 rounded-full flex items-center justify-center mb-3">
          <Phone className="h-6 w-6 text-secondary" />
        </div>
        <h3 className="font-semibold mb-1 text-primary text-sm">Call Us</h3>
        <p className="text-primary/70 text-xs">(512) 817-3552</p>
      </a>
    </div>;
};
export default ContactCards;